var _a, _b;
import { Settings } from '../../Settings';
import { emitInlineStack } from './emitInlineVars';
import { axCoerceNumber } from '../../run/axCoerceNumber';
import { axCoerceInt } from '../../run/axCoerceInt';
import { axCoerceUint } from '../../run/axCoerceUint';
import { axCoerceBoolean } from '../../run/axCoerceBoolean';
import { axCoerceString } from '../../run/axCoerceString';
var typeToCoerceMapping = (_a = {},
    _a['Number'] = function (x) {
        if (Settings.FOLLOW_AS3_BUG) {
            return "sec.AXNumber.axCoerce(" + x + ")";
        }
        return "(+ " + x + ")";
    },
    _a['int'] = function (x) {
        if (Settings.FOLLOW_AS3_BUG) {
            return "sec.AXNumber.axCoerce(" + x + ") | 0";
        }
        return "(" + x + " | 0)";
    },
    _a['uint'] = function (x) { return "(" + x + " >>> 0)"; },
    _a['Boolean'] = function (x) { return "(!! " + x + ")"; },
    _a['String'] = function (x) { return "(" + x + " == null ? null : '' +  " + x + ")"; },
    _a);
var staticCoerceMapping = (_b = {},
    _b['Number'] = axCoerceNumber,
    _b['int'] = axCoerceInt,
    _b['uint'] = axCoerceUint,
    _b['Boolean'] = axCoerceBoolean,
    _b['String'] = axCoerceString,
    _b);
export function emitCoerce(state, stackIndex, type) {
    var inline = emitInlineStack(state, stackIndex);
    if (!type || !type.name || !(type.name in typeToCoerceMapping)) {
        return inline;
    }
    var constAlias = state.getConstAliasMeta(stackIndex);
    // coerce inline for const, const will be transformed to specific type in compiler state
    if (constAlias && constAlias.isConst) {
        var res = staticCoerceMapping[type.name](constAlias.value);
        if (typeof res === 'string')
            return JSON.stringify(res);
        return '' + res;
    }
    return typeToCoerceMapping[type.name](emitInlineStack(state, stackIndex));
}
